export default __webpack_public_path__ + "static/media/loadingEnabill2.c76b9d38.svg";